import { useState, useEffect } from "react"
import AddressForm from "./User_Address/address_form"
import { useSnackbar } from "../../context/snackbar"
export default function AddressPanel({ user, setTab }) {
  const [addresses, setAddresses] = useState([])
  const [showModal, setShowModal] = useState(false)
  const [newAddr, setNewAddr] = useState({})
  const { showSnackbar } = useSnackbar()
  const API = process.env.REACT_APP_API_URL

  useEffect(() => {
    if (user?.addresses) {
      setAddresses(user.addresses)
    }
  }, [user])

  const deleteAddress = async (id) => {
    if (!window.confirm("Delete this address?")) return

    const res = await fetch(`${API}/me/addresses/${id}`, {
      method: "DELETE",
      credentials: "include",
    })

    if (res.ok) {
      setAddresses((prev) => prev.filter((a) => a._id !== id))
      showSnackbar("Address deleted")
    } else {
      showSnackbar("Failed to delete address", "error")
    }
  }
  const updateAddress = async (id, data) => {
    try {
      const res = await fetch(`${API}/me/addresses/${id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify(data),
      })

      if (!res.ok) throw new Error("Update failed")

      const updated = await res.json()
      setAddresses(updated)

      showSnackbar("Address updated")

      return { success: true }
    } catch (err) {
      showSnackbar(err.message, "error")
      return { success: false, message: err.message }
    }
  }

  const addAddress = async () => {
    try {
      const res = await fetch(`${API}/me/addresses`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify(newAddr),
      })

      if (!res.ok) throw new Error("Failed to add address")

      const updated = await res.json()
      setAddresses(updated)
      setShowModal(false)
      setNewAddr({})

      showSnackbar("Address added successfully")
    } catch (err) {
      showSnackbar(err.message, "error")
    }
  }

  return (
    <div className="container mt-4">
      {/* Header */}
      <div className="d-flex align-items-center mb-3">
        <button onClick={() => setTab("home")} className="btn btn-light me-2">
          ←
        </button>
        <h3 className="mb-0">Your Addresses</h3>
      </div>

      {/* Add Button */}
      <button
        className="btn btn-primary mb-3"
        onClick={() => setShowModal(true)}
      >
        + Add Address
      </button>

      {/* ✅ REAL MODAL */}
      {showModal && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{ background: "rgba(0,0,0,0.5)", zIndex: 999 }}
        >
          <div className="bg-white p-4 rounded" style={{ width: "600px" }}>
            <h5>Add Address</h5>

            {[
              ["full_name", "Contact Person"],
              ["address1", "Address Line 1"],
              ["address2", "Address Line 2"],
              ["city", "City"],
              ["state", "State"],
              ["zip", "ZIP Code"],
              ["country", "Country"],
            ].map(([key, label]) => (
              <div className="mb-2" key={key}>
                <label className="form-label small text-muted mb-1 text-start w-100">
                  {label}
                </label>
                <input
                  className="form-control"
                  value={newAddr[key] || ""}
                  onChange={(e) =>
                    setNewAddr({ ...newAddr, [key]: e.target.value })
                  }
                />
              </div>
            ))}

            <div className="mt-3">
              <button className="btn btn-success me-2" onClick={addAddress}>
                Save
              </button>
              <button
                className="btn btn-secondary"
                onClick={() => setShowModal(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ✅ EMPTY STATE FIX */}
      {addresses.length === 0 && (
        <div className="text-muted">No addresses found.</div>
      )}

      {/* Existing */}
      {addresses.map((addr, index) => (
        <AddressForm
          key={addr._id}
          addr={addr}
          index={index}
          showDelete={true}
          onDelete={deleteAddress}
          onUpdate={updateAddress}
        />
      ))}
    </div>
  )
}
